import React from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import { connect } from 'redaction'
import { createSelector } from 'reselect'
import actions from 'redux/actions'
import {
  compose, constants, filterNav, getTrackingEventToNavItem,
  links, mixpanel, getNotEmptyCosmeticsCategories,
} from 'common/helpers'
import { getNavFromStructure } from 'common/helpers/getters'
import createDeepEqualSelector from 'common/helpers/misc/createDeepEqualSelector'

import injectGlobals from 'decorators/injectGlobals'

import ExceptMobile from './ExceptMobile/ExceptMobile'
import Mobile from './Mobile/Mobile'

import messages from './messages'

import s from './HeaderSubNav.scss'

// resolve picture x2
import goldCollectionImage from './images/gold-collection.jpg'
// resolve picture x2
import bambooCollection from './images/bamboo-collection.jpg'
// resolve picture x2
import lipsBalmsImage from './images/lips-balms.jpg'
// resolve picture x2
import giftSubscriptionImage from './images/gift-subscription.jpg'
// resolve picture x2
import giftCardsImage from './images/gift-cards.jpg'
// resolve picture x2
import personalCareManBanner from './images/personal-care-man-banner.png'
// resolve picture x2
import personalCareWomanBanner from './images/personal-care-woman-banner.png'


const onCollectionsClick = () =>
  actions.misc.cookies.setSessionItem(constants.cookieNames.collectionsClickPlacement, 'navigation dropdown')

const getTrackingEvents = (item) => (
  getTrackingEventToNavItem(item, {
    snowplowEvent: constants.snowplowEvents.navigationMenuClick,
  })
)

const getNav = (props, cosmeticsPage, gender, navigation) => {
  const { notEmptyTypes, structure } = cosmeticsPage

  const { skincare, makeup, personalCare } = constants.cosmeticsCategories
  const {
    isCollectionsEnabled,
    isFatherDayBambooGiftSetEnabled,
    isPopularInStatesHidden,
    isFragranceFinderHidden,
    isFragranceHoroscopeHidden,
    isGiftsHidden,
    isSeparateWellnessEnabled,
  } = props

  const isMale = gender === 'male'

  const isNewSkincareStructureEnabled = Boolean(structure && structure.skincare)
  const isSeparateWellnessVisible = Boolean(isSeparateWellnessEnabled && structure && structure.wellness)

  const nav = filterNav([
    {
      title: messages.main,
      subNav: [
        { title: messages.men, to: links.subscription.mainMen, dataTestId: constants.testIds.headerSubNav.men },
        { title: messages.women, to: links.subscription.mainWomen, dataTestId: constants.testIds.headerSubNav.women },
      ],
      dataTestId: constants.testIds.headerSubNav.main,
    },
    {
      linkId: 'onboard_step2',
      title: messages.fineFragrance,
      dataTestId: constants.testIds.headerSubNav.fineFragrance,
      subNav: [
        { title: messages.perfumes, to: links.subscription.perfumes, dataTestId: constants.testIds.headerSubNav.perfumes },
        { title: messages.colognes, to: links.subscription.colognes, dataTestId: constants.testIds.headerSubNav.colognes },
        { title: messages.recommendations, to: links.subscription.recommendations, dataTestId: constants.testIds.headerSubNav.recommendations },
        (
          !isPopularInStatesHidden && (
            { title: messages.fragranceByState, to: links.popularInStates, dataTestId: constants.testIds.headerSubNav.popularInStates }
          )
        ),
        (
          isCollectionsEnabled && (
            {
              title: messages.collectionsWomen,
              to: links.subscription.collectionsWomen,
              onClick: onCollectionsClick,
              dataTestId: constants.testIds.headerSubNav.collectionsWomen,
            }
          )
        ),
        (
          isCollectionsEnabled && (
            {
              title: messages.collectionsMen,
              to: links.subscription.collectionsMen,
              onClick: onCollectionsClick,
              dataTestId: constants.testIds.headerSubNav.collectionsMen,
            }
          )
        ),
        { title: messages.perfumeOfTheMonth, to: links.subscription.currPerfumeOfTheMonth, dataTestId: constants.testIds.headerSubNav.currPerfumeOfTheMonth },
        { title: messages.cologneOfTheMonth, to: links.subscription.currCologneOfTheMonth, dataTestId: constants.testIds.headerSubNav.currCologneOfTheMonth },
        { title: messages.extras, to: links.subscription.extras, dataTestId: constants.testIds.headerSubNav.extras },
        (
          !isFragranceHoroscopeHidden && (
            { title: messages.horoscope, to: links.horoscope, dataTestId: constants.testIds.headerSubNav.horoscope }
          )
        ),
        (
          !isFragranceFinderHidden && (
            { title: messages.fragranceFinder, to: links.fragranceFinder, dataTestId: constants.testIds.headerSubNav.fragranceFinder }
          )
        ),
      ],
      dropdown: [
        {
          type: 'nav',
          nav: [
            { title: messages.perfumes, to: links.subscription.perfumes, lg: true, dataTestId: constants.testIds.headerSubNav.perfumes },
            { title: messages.colognes, to: links.subscription.colognes, lg: true, dataTestId: constants.testIds.headerSubNav.colognes },
            { title: messages.perfumeOfTheMonth, to: links.subscription.currPerfumeOfTheMonth, dataTestId: constants.testIds.headerSubNav.currPerfumeOfTheMonth },
            { title: messages.cologneOfTheMonth, to: links.subscription.currCologneOfTheMonth, dataTestId: constants.testIds.headerSubNav.currCologneOfTheMonth },
            {
              title: messages.collectionsWomen,
              to: links.subscription.collectionsWomen,
              onClick: onCollectionsClick,
              dataTestId: constants.testIds.headerSubNav.collectionsWomen,
            },
            {
              title: messages.collectionsMen,
              to: links.subscription.collectionsMen,
              onClick: onCollectionsClick,
              dataTestId: constants.testIds.headerSubNav.collectionsMen,
            },
            { title: messages.extras, to: links.subscription.extras, dataTestId: constants.testIds.headerSubNav.extras },
            (
              !isFragranceHoroscopeHidden && (
                { title: messages.horoscope, to: links.horoscope, dataTestId: constants.testIds.headerSubNav.horoscope }
              )
            ),

            (
              !isFragranceFinderHidden && (
                { title: messages.fragranceFinder, to: links.fragranceFinder, dataTestId: constants.testIds.headerSubNav.fragranceFinder }
              )
            ),
            {
              title: messages.recommendations, to: links.subscription.recommendations,
              lg: true, spaceBefore: true,
              dataTestId: constants.testIds.headerSubNav.recommendations,
            },
          ],
        },
        {
          type: 'nav',
          nav: [
            { title: messages.brands, lg: true, dataTestId: constants.testIds.headerSubNav.brands },
            ...(
              Boolean(navigation.fragrances.brands) && navigation.fragrances.brands.length ? (
                navigation.fragrances.brands.map((brand) => ({
                  title: brand,
                  to: `${isMale ? links.subscription.colognes : links.subscription.perfumes}?brand=${encodeURIComponent(brand)}`,
                  dataTestId: constants.testIds.headerSubNav.brand,
                }))
              ) : (
                []
              )
            ),
          ],
        },
        {
          type: 'collections',
          titleProps: getTrackingEvents({
            title: messages.collections,
            dataTestId: constants.testIds.headerSubNav.collections,
            to: isMale ? links.subscription.collectionsMen : links.subscription.collectionsWomen,
          }),
          browseAllProps: getTrackingEvents({
            title: messages.browseAll,
            dataTestId: constants.testIds.headerSubNav.browseAll,
            to: isMale ? links.subscription.collectionsMen : links.subscription.collectionsWomen,
          }),
          placement: 'collections',
          collections: navigation.fragrances.collections,
          isFetching: navigation.isFetching,
        },
        {
          type: 'product',
          titleProps: getTrackingEvents({
            title: isMale ? messages.cologneOfTheMonth : messages.perfumeOfTheMonth,
            dataTestId: constants.testIds.headerSubNav.fragranceOfTheMonth,
            to: isMale ? links.subscription.currCologneOfTheMonth : links.subscription.currPerfumeOfTheMonth,
          }),
          placement: 'perfume of the month image',
          product: navigation.fragrances.fragranceOfTheMonth,
          addButtonProps: {
            metadata: {
              placement: 'navigation dropdown',
            },
            snowplowMetadata: {
              placement: 'navigation dropdown',
            },
          },
          isFetching: navigation.isFetching,
        },
      ],
    },
    {
      title: messages.makeup,
      dataTestId: constants.testIds.headerSubNav.makeup,
      subNav: [
        { title: messages.allMakeup, to: links.makeup, dataTestId: constants.testIds.headerSubNav.allMakeup },
        ...(
          getNotEmptyCosmeticsCategories({
            root: makeup.name,
            types: notEmptyTypes,
            categories: [
              {
                title: messages.palettes,
                name: makeup.categories.palettes,
                to: links.makeupPalettes,
                dataTestId: constants.testIds.headerSubNav.palettes,
              },
              {
                title: messages.eye,
                name: makeup.categories.eye,
                to: links.makeupEye,
                dataTestId: constants.testIds.headerSubNav.eye,
              },
              {
                title: messages.lip,
                name: makeup.categories.lip,
                to: links.makeupLip,
                dataTestId: constants.testIds.headerSubNav.lip,
              },
              {
                title: messages.face,
                name: makeup.categories.face,
                to: links.makeupFace,
                dataTestId: constants.testIds.headerSubNav.face,
              },
              {
                title: messages.cheek,
                name: makeup.categories.cheek,
                to: links.makeupCheek,
                dataTestId: constants.testIds.headerSubNav.cheek,
              },
              {
                title: messages.tools,
                name: makeup.categories.tools,
                to: links.makeupTools,
                dataTestId: constants.testIds.headerSubNav.tools,
              },
            ],
          })
        ),
      ],
      dropdown: [
        {
          type: 'nav',
          nav: [
            { title: messages.allMakeup, to: links.makeup, lg: true, dataTestId: constants.testIds.headerSubNav.allMakeup },
            ...(
              getNotEmptyCosmeticsCategories({
                root: makeup.name,
                types: notEmptyTypes,
                categories: [
                  {
                    title: messages.palettes,
                    name: makeup.categories.palettes,
                    to: links.makeupPalettes,
                    dataTestId: constants.testIds.headerSubNav.palettes,
                  },
                  {
                    title: messages.eye,
                    name: makeup.categories.eye,
                    to: links.makeupEye,
                    dataTestId: constants.testIds.headerSubNav.eye,
                  },
                  {
                    title: messages.lip,
                    name: makeup.categories.lip,
                    to: links.makeupLip,
                    dataTestId: constants.testIds.headerSubNav.lip,
                  },
                  {
                    title: messages.face,
                    name: makeup.categories.face,
                    to: links.makeupFace,
                    dataTestId: constants.testIds.headerSubNav.face,
                  },
                  {
                    title: messages.cheek,
                    name: makeup.categories.cheek,
                    to: links.makeupCheek,
                    dataTestId: constants.testIds.headerSubNav.cheek,
                  },
                  {
                    title: messages.tools,
                    name: makeup.categories.tools,
                    to: links.makeupTools,
                    dataTestId: constants.testIds.headerSubNav.tools,
                  },
                ],
              })
            ),
          ],
        },
        {
          type: 'nav',
          nav: [
            { title: messages.brands, lg: true, dataTestId: constants.testIds.headerSubNav.brands },
            ...(
              Boolean(navigation.makeup.brands) && navigation.makeup.brands.length ? (
                navigation.makeup.brands.map((brand) => ({
                  title: brand,
                  to: `${links.makeup}?brand=${encodeURIComponent(brand)}`,
                  dataTestId: constants.testIds.headerSubNav.brand,
                }))
              ) : (
                []
              )
            ),
          ],
        },
        {
          type: 'collections',
          titleProps: getTrackingEvents({
            title: messages.makeupCollections,
            to: links.subscription.collectionsWomen,
            dataTestId: constants.testIds.headerSubNav.makeupCollections,
          }),
          browseAllProps: getTrackingEvents({
            title: messages.browseAll,
            to: links.subscription.collectionsWomen,
            dataTestId: constants.testIds.headerSubNav.browseAll,
          }),
          placement: 'makeup collections',
          collections: navigation.makeup.collections,
          isFetching: navigation.isFetching,
        },
        {
          type: 'product',
          titleProps: {
            title: messages.ourFavorite,
            dataTestId: constants.testIds.headerSubNav.ourFavorite,
          },
          placement: 'favorite makeup image',
          product: navigation.makeup.favorite,
          addButtonProps: {
            metadata: {
              placement: 'navigation dropdown',
            },
            snowplowMetadata: {
              placement: 'navigation dropdown',
            },
          },
          isFetching: navigation.isFetching,
        },
      ],
    },
    {
      title: messages.skincare,
      dataTestId: constants.testIds.headerSubNav.skincare,
      isBig: isNewSkincareStructureEnabled,
      subNav: isNewSkincareStructureEnabled
        ? getNavFromStructure({ structure: structure.skincare, root: 'skincare' })
        : [
          { title: messages.allSkincare, to: links.skincare, dataTestId: constants.testIds.headerSubNav.allSkincare },
          { title: messages.collectionsForWomen, to: links.skincareCollectionWomen, dataTestId: constants.testIds.headerSubNav.collectionsForWomen },
          { title: messages.collectionsForMen, to: links.skincareCollectionMen, dataTestId: constants.testIds.headerSubNav.collectionsForMen },
          ...getNotEmptyCosmeticsCategories({
            root: skincare.name,
            types: notEmptyTypes,
            categories: [
              { title: messages.bodyLip, to: links.skincareLip, name: skincare.categories.lip, dataTestId: constants.testIds.headerSubNav.bodyLip },
              { title: messages.skincareEye, to: links.skincareEye, name: skincare.categories.eye, dataTestId: constants.testIds.headerSubNav.skincareEye },
              { title: messages.cleansers, to: links.skincareCleansers, name: skincare.categories.cleansers, dataTestId: constants.testIds.headerSubNav.cleansers },
              { title: messages.masks, to: links.skincareMasks, name: skincare.categories.masks, dataTestId: constants.testIds.headerSubNav.masks },
              { title: messages.moisturizers, to: links.skincareMoisturizers, name: skincare.categories.moisturizers, dataTestId: constants.testIds.headerSubNav.moisturizers },
              { title: messages.treatments, to: links.skincareTreatments, name: skincare.categories.treatments, dataTestId: constants.testIds.headerSubNav.treatments },
              { title: messages.mens, to: links.skincareMens, name: skincare.categories.mens, dataTestId: constants.testIds.headerSubNav.mens },
              { title: messages.wellness, to: links.skincareWellness, name: skincare.categories.wellness, dataTestId: constants.testIds.headerSubNav.wellness },
            ],
          }),
        ],
      dropdown: [
        ...isNewSkincareStructureEnabled
          ? getNavFromStructure({ structure: structure.skincare, root: 'skincare', isDropdown: true })
          : [{
            type: 'nav',
            nav: [
              { title: messages.allSkincare, to: links.skincare, lg: true, dataTestId: constants.testIds.headerSubNav.allSkincare },
              { title: messages.collectionsForWomen, to: links.skincareCollectionWomen, dataTestId: constants.testIds.headerSubNav.collectionsForWomen },
              { title: messages.collectionsForMen, to: links.skincareCollectionMen, dataTestId: constants.testIds.headerSubNav.collectionsForMen },
              ...getNotEmptyCosmeticsCategories({
                root: skincare.name,
                types: notEmptyTypes,
                categories: [
                  { title: messages.bodyLip, to: links.skincareLip, name: skincare.categories.lip, dataTestId: constants.testIds.headerSubNav.lip },
                  { title: messages.skincareEye, to: links.skincareEye, name: skincare.categories.eye, dataTestId: constants.testIds.headerSubNav.eye },
                  { title: messages.cleansers, to: links.skincareCleansers, name: skincare.categories.cleansers, dataTestId: constants.testIds.headerSubNav.cleansers },
                  { title: messages.masks, to: links.skincareMasks, name: skincare.categories.masks, dataTestId: constants.testIds.headerSubNav.masks },
                  { title: messages.moisturizers, to: links.skincareMoisturizers, name: skincare.categories.moisturizers, dataTestId: constants.testIds.headerSubNav.moisturizers },
                  { title: messages.treatments, to: links.skincareTreatments, name: skincare.categories.treatments, dataTestId: constants.testIds.headerSubNav.treatments },
                  { title: messages.mens, to: links.skincareMens, name: skincare.categories.mens, dataTestId: constants.testIds.headerSubNav.mens },
                  { title: messages.wellness, to: links.skincareWellness, name: skincare.categories.wellness, dataTestId: constants.testIds.headerSubNav.wellness },
                ],
              }),
            ],
          },
          {
            // for empty block
            type: 'nav',
            nav: [],
          }],
        (
          isMale ? ({
            type: 'card',
            ...getTrackingEvents({
              title: messages.bambooCharcoalCollection,
              to: links.bambooCharcoalCollection,
              dataTestId: constants.testIds.headerSubNav.bambooCharcoalCollection,
            }),
            image: bambooCollection,
            imageContainerClass: s.imageContainer,
            badge: 'bamboo',
          }) : ({
            type: 'card',
            ...getTrackingEvents({
              title: messages.goldCollection,
              to: links.goldCollectionWomen,
              dataTestId: constants.testIds.headerSubNav.goldCollection,
            }),
            image: goldCollectionImage,
            imageContainerClass: s.imageContainer,
            badge: 'gold',
          })
        ),

        {
          type: 'card',
          ...getTrackingEvents({
            title: messages.naturalLipBalms,
            to: links.skincareLip,
            dataTestId: constants.testIds.headerSubNav.naturalLipBalms,
          }),
          image: lipsBalmsImage,
          imageContainerClass: s.skincareImageContainer,
          small: true,
        },
      ],
    },
    ...(
      isSeparateWellnessVisible ? [{
        title: messages.wellness,
        dataTestId: constants.testIds.headerSubNav.wellness,
        subNav: getNavFromStructure({ structure: structure.wellness, root: 'wellness' }),
      }] : []
    ),
    {
      title: messages.personalCare,
      subNav: [
        { title: messages.allPersonalCare, to: links.personalCare, dataTestId: constants.testIds.headerSubNav.allPersonalCare },
        ...getNotEmptyCosmeticsCategories({
          root: personalCare.name,
          types: notEmptyTypes,
          bodyMoisturizers: 'bodyMoisturizers',
          handCreams: 'handCreams',
          shower: 'shower',
          categories: [
            { title: messages.bodyMoisturizers, to: links.personalCareBodyMoisturizers, name: personalCare.categories.bodyMoisturizers, dataTestId: constants.testIds.headerSubNav.bodyMoisturizers },
            { title: messages.handCreams, to: links.personalCareHandCreams, name: personalCare.categories.handCreams, dataTestId: constants.testIds.headerSubNav.handCreams },
            { title: messages.shower, to: links.personalCareShower, name: personalCare.categories.shower, dataTestId: constants.testIds.headerSubNav.shower },
          ],
        }),
      ],
      dropdown: [
        {
          type: 'nav',
          nav: [
            { title: messages.allPersonalCare, to: links.personalCare, lg: true, dataTestId: constants.testIds.headerSubNav.allPersonalCare },
            { title: messages.bodyMoisturizers, to: links.personalCareBodyMoisturizers, dataTestId: constants.testIds.headerSubNav.bodyMoisturizers },
            { title: messages.handCreams, to: links.personalCareHandCreams, dataTestId: constants.testIds.headerSubNav.handCreams },
            { title: messages.shower, to: links.personalCareShower, dataTestId: constants.testIds.headerSubNav.shower },
          ],
        },
        {
          type: 'nav',
          nav: (() => {
            const topElements     = [{ title: messages.bodyWash, lg: true, dataTestId: constants.testIds.headerSubNav.bodyWash }]
            const bottomElements  = isMale
              ? [{ title: messages.bodyMoisturizers, lg: true, dataTestId: constants.testIds.headerSubNav.bodyMoisturizers }]
              : [{ title: messages.handCreams, lg: true, dataTestId: constants.testIds.headerSubNav.handCreams }]

            navigation.personalCare.products.forEach(({ type, name: title, url: to }) => (
              type === constants.cosmeticsProductTypes.personalCare.shower.bodyWash
                ? topElements
                : bottomElements
            ).push({ title, to }))

            return [ ...topElements, ...bottomElements ]
          })(),
        },
        (
          isMale ? ({
            type: 'card',
            ...getTrackingEvents({
              title: messages.handCreams,
              to: links.personalCareHandCreams,
              dataTestId: constants.testIds.headerSubNav.handCreams,
            }),
            image: personalCareManBanner,
            imageContainerClass: s.imageContainer,
          }) : ({
            type: 'card',
            ...getTrackingEvents({
              title: messages.bodyMoisturizers,
              to: links.personalCareBodyMoisturizers,
              dataTestId: constants.testIds.headerSubNav.bodyMoisturizers,
            }),
            image: personalCareWomanBanner,
            imageContainerClass: s.imageContainer,
          })
        ),
        {
          type: 'product',
          titleProps: {
            title: messages.bestseller,
            dataTestId: constants.testIds.headerSubNav.bestseller,
          },
          placement: 'bestseller personal care image',
          product: navigation.personalCare.bestseller,
          hideBrand: true,
          addButtonProps: {
            metadata: {
              placement: 'navigation dropdown',
            },
            snowplowMetadata: {
              placement: 'navigation dropdown',
            },
          },
          isFetching: navigation.isFetching,
        },
      ],
    },
    {
      title: messages.candles,
      dataTestId: constants.testIds.headerSubNav.candles,
      subNav: [
        { title: messages.scentedCandles, to: links.candles, dataTestId: constants.testIds.headerSubNav.scentedCandles, },
      ],
      dropdown: [
        {
          type: 'nav',
          nav: [
            { title: messages.scentedCandles, to: links.candles, lg: true, dataTestId: constants.testIds.headerSubNav.scentedCandles },
            ...(Boolean(navigation.candles.products) && navigation.candles.products.length ? (
              navigation.candles.products.map((item) => ({
                title: item.name,
                to: item.url,
              }))
            ) : (
              []
            )),
          ],
        },
        // Placeholder
        {
          type: 'text',
          text: '',
        },
        {
          type: 'product',
          titleProps: {
            title: messages.bestseller,
            dataTestId: constants.testIds.headerSubNav.bestseller,
          },
          placement: 'bestseller candle image',
          product: navigation.candles.bestseller,
          hideBrand: true,
          subtitle: messages.scentedCandles,
          addButtonProps: {
            metadata: {
              placement: 'navigation dropdown',
            },
            snowplowMetadata: {
              placement: 'navigation dropdown',
            },
          },
          isFetching: navigation.isFetching,
        },
        {
          type: 'product',
          titleProps: {
            title: messages.ourFavorite,
            dataTestId: constants.testIds.headerSubNav.ourFavorite,
          },
          placement: 'favorite candle image',
          product: navigation.candles.favorite,
          hideBrand: true,
          subtitle: messages.scentedCandles,
          addButtonProps: {
            metadata: {
              placement: 'navigation dropdown',
            },
            snowplowMetadata: {
              placement: 'navigation dropdown',
            },
          },
          isFetching: navigation.isFetching,
        },
      ],
    },
    {
      title: messages.gifts,
      dataTestId: constants.testIds.headerSubNav.gifts,
      subNav: [
        ...(
          isFatherDayBambooGiftSetEnabled ? [
            { title: messages.fathersDay, to: links.fathersDayGiftSet, dataTestId: 'fatherDay' },
          ] : []
        ),
        { title: messages.allGifts, to: links.gifts, dataTestId: constants.testIds.headerSubNav.gifts },
        { title: messages.giftCard, to: links.giftCard, dataTestId: constants.testIds.headerSubNav.giftCard },
        ...(
          !isGiftsHidden ? [
            { title: messages.giftSetsMen, to: links.giftSetsMen, dataTestId: constants.testIds.headerSubNav.giftSetsMen },
            { title: messages.giftSetsWomen, to: links.giftSet, dataTestId: constants.testIds.headerSubNav.giftSet },
          ] : []
        ),
        { title: messages.skincareSets, to: links.skincareSets, dataTestId: constants.testIds.headerSubNav.skincareSets },
        { title: messages.giftSubscription, to: links.gift, dataTestId: constants.testIds.headerSubNav.giftSubscription },
      ],
      dropdown: [
        {
          type: 'nav',
          nav: [
            ...(
              isFatherDayBambooGiftSetEnabled ? [
                { title: messages.fathersDay, to: links.fathersDayGiftSet, lg: true, dataTestId: 'fatherDay' },
              ] : []
            ),
            { title: messages.allGifts, to: links.gifts, lg: true, dataTestId: constants.testIds.headerSubNav.allGifts },
            ...(
              !isGiftsHidden ? [
                { title: messages.giftSetsWomen, to: links.giftSet, dataTestId: constants.testIds.headerSubNav.giftSet },
                { title: messages.giftSetsMen, to: links.giftSetsMen, dataTestId: constants.testIds.headerSubNav.giftSetsMen },
              ] : []
            ),
            { title: messages.skincareSets, to: links.skincareSets, dataTestId: constants.testIds.headerSubNav.skincareSets },
          ],
        },
        {
          type: 'card',
          ...getTrackingEvents({
            title: messages.giftSubscription,
            to: links.gift,
            dataTestId: constants.testIds.headerSubNav.giftSubscription,
          }),
          image: giftSubscriptionImage,
          transparent: true,
        },
        {
          type: 'card',
          ...getTrackingEvents({
            title: messages.giftCards,
            to:  links.giftCard,
            dataTestId: constants.testIds.headerSubNav.giftCards,
          }),
          image: giftCardsImage,
          transparent: true,
        },
      ],
    },
    {
      title: messages.blog,
      toOLD: links.blog,
      dataTestId: constants.testIds.headerSubNav.blog,
      onClick: () => mixpanel.track(constants.analyticsEvents.blog, { placement: 'header' }),
    },
  ])
    .map((item) => {
      if (!item.subNav && !item.dropdown) {
        return item
      }

      let { subNav, dropdown } = item

      if (item.subNav) {
        subNav = item.subNav.map((subItem) => getTrackingEvents(subItem))
      }

      if (item.dropdown) {
        dropdown = item.dropdown.map((dropdownItem) => {
          if (!dropdownItem.nav) {
            return dropdownItem
          }

          const nav = dropdownItem.nav.map((subItem) => getTrackingEvents(subItem))
          return { ...dropdownItem, nav }
        })
      }

      return {
        ...item,
        subNav,
        dropdown,
      }
    })

  return {
    nav,
    gender,
  }
}


const HeaderSubNav = (props) => {
  const { nav, gender, isDesktopDropdownEnabled, isFatherDayBambooGiftSetEnabled } = props

  return (
    <Media mobile>
      {
        (isMobile) => (
          <Media desktop>
            {
              (isDesktop) =>
                React.createElement(
                  isMobile ? Mobile : ExceptMobile,
                  {
                    nav,
                    gender,
                    isDesktopDropdownEnabled: isDesktop && isDesktopDropdownEnabled,
                    isFatherDayBambooGiftSetEnabled,
                  },
                )
            }
          </Media>
        )
      }
    </Media>
  )
}

HeaderSubNav.propTypes = {
  gender: PropTypes.string,
  nav: PropTypes.array,
  isDesktopDropdownEnabled: PropTypes.bool,
}

// Prevent creating new object
const propsSelector = createDeepEqualSelector(
  (props) => props,
  (props) => props,
)

export default compose(
  injectGlobals(({ getFeatureToggle, getAbValue }) => ({
    isCollectionsEnabled: getFeatureToggle(constants.features.productsCollections),
    isDesktopDropdownEnabled: getAbValue(constants.abTests.menuDesktopDropdown) === 'b',
    isFatherDayBambooGiftSetEnabled: getFeatureToggle(constants.features.fatherDayBambooGiftSet),
    isPopularInStatesHidden: getFeatureToggle(constants.features.hidePopularInStates),
    isFragranceFinderHidden: getFeatureToggle(constants.features.hideFragranceFinder),
    isFragranceHoroscopeHidden: getFeatureToggle(constants.features.hideFragranceHoroscope),
    isGiftsHidden: getFeatureToggle(constants.features.hideGifts),
    isSeparateWellnessEnabled: getFeatureToggle(constants.features.separateWellness),
  })),
  connect(createSelector(
    (_, props) => propsSelector(props),
    (state) => state.view.cosmeticsPage,
    (state) => state.models.me.gender || 'female',
    (state) => state.view.navigation,
    getNav,
  )),
)(HeaderSubNav)
